const Colors = {
  primaryColor: '#007bff',
  white: '#ffff',
  textInputBg: '#F4F5F9',
  // black: '#1D2129',
  lightBlue: '#F0F5FF',
  darkGray: '#4A505C',
  pinch: '#1D2129',
  deleteRed: '#D11A2A',


  adminPrimaryColor: '#363740',
  defaultColor: '#A4A6B3',
  textLightColor: '#8A92A6',
  lightBlackColor: '#232D42',
  breadCrumbsColor: '#727272',
  black: '#161B25',
  headingBlackColor: '#000000',
  bgColor: '#DEDEDE',
  red: '#FF0000',
  darkBlue: '#000AFF',
  lightBlack: '#344054',
  paginationTitle: '#181818',
  searchPlaceholder: '#667085',
  borderColor: '#D3D3D3'
}

export default Colors;